module.exports = require('./helpers/bundle-url').getBundleURL('4afSR') + "fail.05e16182.png";